import Component from '@glimmer/component';

interface ParallaxSceneArgs {
  height?: string; // e.g. 'h-[80vh]' | 'h-screen' | 'h-auto sm:h-screen'
  overlay?: boolean;
}

export default class ParallaxScene extends Component<ParallaxSceneArgs> {
  get baseClass() {
    const height = this.args.height ?? 'h-auto sm:h-screen';
    return `relative grid place-items-center ${height}`;
  }

  <template>
    <div class={{this.baseClass}} ...attributes>
      {{yield}}
    </div>
  </template>
}
